var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-group col-md-12 mb-4" },
    [
      _vm.isForeignKey
        ? [
            _c("label", [
              _vm._v(_vm._s(_vm.fieldName) + " "),
              !_vm.isNullable
                ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isNullable
              ? [
                  _c("select2", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid":
                        _vm.errors.has(_vm.fieldName) && _vm.itemValue === null
                    },
                    attrs: {
                      value: _vm.select2Value,
                      "plugin-options": _vm.searchOptions,
                      "is-ajax": true,
                      "data-vv-name": _vm.fieldName
                    },
                    on: { input: _vm.onSelect2 }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errorMessages, function(message) {
                    return _c("div", { staticClass: "invalid-feedback" }, [
                      _vm._v(_vm._s(message))
                    ])
                  })
                ]
              : [
                  _c("select2", {
                    staticClass: "form-control",
                    attrs: {
                      value: _vm.select2Value,
                      "plugin-options": _vm.searchOptions,
                      "is-ajax": true
                    },
                    on: { input: _vm.onSelect2 }
                  })
                ]
          ]
        : [
            _vm.type === "string"
              ? [
                  _vm.isUrl
                    ? [
                        _vm.isNullable
                          ? [
                              _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { regex: _vm.urlPattern },
                                    expression: "{ regex: urlPattern }"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.itemValue,
                                    expression: "itemValue"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(_vm.fieldName)
                                },
                                attrs: {
                                  "data-vv-name": _vm.fieldName,
                                  maxlength: _vm.maxLength,
                                  type: "text"
                                },
                                domProps: { value: _vm.itemValue },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.itemValue = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.errorMessages, function(message) {
                                return _c(
                                  "div",
                                  { staticClass: "invalid-feedback" },
                                  [_vm._v(_vm._s(message))]
                                )
                              })
                            ]
                          : [
                              _c("label", [
                                _vm._v(_vm._s(_vm.fieldName) + " "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      regex: _vm.urlPattern
                                    },
                                    expression:
                                      "{ required: true, regex: urlPattern }"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.itemValue,
                                    expression: "itemValue"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(_vm.fieldName)
                                },
                                attrs: {
                                  "data-vv-name": _vm.fieldName,
                                  maxlength: _vm.maxLength,
                                  type: "text"
                                },
                                domProps: { value: _vm.itemValue },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.itemValue = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.errorMessages, function(message) {
                                return _c(
                                  "div",
                                  { staticClass: "invalid-feedback" },
                                  [_vm._v(_vm._s(message))]
                                )
                              })
                            ]
                      ]
                    : _vm.isMultiline
                    ? [
                        _vm.isNullable
                          ? [
                              _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                              _vm._v(" "),
                              _c("textarea-autosize", {
                                ref: "autoSizeTextArea",
                                staticClass: "form-control",
                                attrs: {
                                  maxlength: _vm.maxLength,
                                  type: "text",
                                  "min-height": _vm.minTextareaHeight
                                },
                                model: {
                                  value: _vm.itemValue,
                                  callback: function($$v) {
                                    _vm.itemValue = $$v
                                  },
                                  expression: "itemValue"
                                }
                              })
                            ]
                          : [
                              _c("label", [
                                _vm._v(_vm._s(_vm.fieldName) + " "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("textarea-autosize", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                ref: "autoSizeTextArea",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(_vm.fieldName)
                                },
                                attrs: {
                                  "data-vv-name": _vm.fieldName,
                                  maxlength: _vm.maxLength,
                                  type: "text",
                                  "min-height": _vm.minTextareaHeight
                                },
                                model: {
                                  value: _vm.itemValue,
                                  callback: function($$v) {
                                    _vm.itemValue = $$v
                                  },
                                  expression: "itemValue"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.errorMessages, function(message) {
                                return _c(
                                  "div",
                                  { staticClass: "invalid-feedback" },
                                  [_vm._v(_vm._s(message))]
                                )
                              })
                            ]
                      ]
                    : [
                        _vm.isNullable
                          ? [
                              _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.itemValue,
                                    expression: "itemValue"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  maxlength: _vm.maxLength,
                                  type: "text"
                                },
                                domProps: { value: _vm.itemValue },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.itemValue = $event.target.value
                                  }
                                }
                              })
                            ]
                          : [
                              _c("label", [
                                _vm._v(_vm._s(_vm.fieldName) + " "),
                                _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.itemValue,
                                    expression: "itemValue"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(_vm.fieldName)
                                },
                                attrs: {
                                  "data-vv-name": _vm.fieldName,
                                  maxlength: _vm.maxLength,
                                  type: "text"
                                },
                                domProps: { value: _vm.itemValue },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) return
                                    _vm.itemValue = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.errorMessages, function(message) {
                                return _c(
                                  "div",
                                  { staticClass: "invalid-feedback" },
                                  [_vm._v(_vm._s(message))]
                                )
                              })
                            ]
                      ]
                ]
              : _vm.type === "number"
              ? [
                  _vm.isNullable
                    ? [
                        _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            { name: "numeric", rawName: "v-numeric" },
                            {
                              name: "model",
                              rawName: "v-model.number.trim",
                              value: _vm.itemValue,
                              expression: "itemValue",
                              modifiers: { number: true, trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { maxlength: _vm.maxLength, type: "text" },
                          domProps: { value: _vm.itemValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.itemValue = _vm._n($event.target.value.trim())
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]
                    : [
                        _c("label", [
                          _vm._v(_vm._s(_vm.fieldName) + " "),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v("*")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            },
                            { name: "numeric", rawName: "v-numeric" },
                            {
                              name: "model",
                              rawName: "v-model.number.trim",
                              value: _vm.itemValue,
                              expression: "itemValue",
                              modifiers: { number: true, trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has(_vm.fieldName)
                          },
                          attrs: {
                            "data-vv-name": _vm.fieldName,
                            maxlength: _vm.maxLength,
                            type: "text"
                          },
                          domProps: { value: _vm.itemValue },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.itemValue = _vm._n($event.target.value.trim())
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errorMessages, function(message) {
                          return _c(
                            "div",
                            { staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(message))]
                          )
                        })
                      ]
                ]
              : _vm.type === "bool"
              ? [
                  _vm.isNullable
                    ? [
                        _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-check form-check-inline" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-check-label d-flex align-items-center"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.itemValue,
                                        expression: "itemValue"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "radio",
                                      name: "inlineRadioOptions" + _vm.index
                                    },
                                    domProps: {
                                      value: null,
                                      checked: _vm._q(_vm.itemValue, null)
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.itemValue = null
                                      }
                                    }
                                  }),
                                  _vm._v("N/A\n                        ")
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-check form-check-inline" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-check-label d-flex align-items-center"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.itemValue,
                                        expression: "itemValue"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "radio",
                                      name: "inlineRadioOptions" + _vm.index
                                    },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(_vm.itemValue, true)
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.itemValue = true
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$t("common.yes")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-check form-check-inline" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-check-label d-flex align-items-center"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.itemValue,
                                        expression: "itemValue"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "radio",
                                      name: "inlineRadioOptions" + _vm.index
                                    },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(_vm.itemValue, false)
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.itemValue = false
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$t("common.no")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    : [
                        _c("div", { staticClass: "form-check" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.itemValue,
                                  expression: "itemValue"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.itemValue)
                                  ? _vm._i(_vm.itemValue, null) > -1
                                  : _vm.itemValue
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.itemValue,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.itemValue = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.itemValue = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.itemValue = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.fieldName) +
                                "\n                    "
                            )
                          ])
                        ])
                      ]
                ]
              : _vm.type === "date"
              ? [
                  _vm.isNullable
                    ? [
                        _c("label", [_vm._v(_vm._s(_vm.fieldName))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("flat-pickr", {
                              staticClass: "form-control",
                              attrs: { "is-date-time-picker": !_vm.isDateOnly },
                              model: {
                                value: _vm.itemValue,
                                callback: function($$v) {
                                  _vm.itemValue = $$v
                                },
                                expression: "itemValue"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _c("label", [
                          _vm._v(_vm._s(_vm.fieldName) + " "),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v("*")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("flat-pickr", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(_vm.fieldName)
                              },
                              attrs: {
                                "is-date-time-picker": !_vm.isDateOnly,
                                "data-vv-name": _vm.fieldName
                              },
                              model: {
                                value: _vm.itemValue,
                                callback: function($$v) {
                                  _vm.itemValue = $$v
                                },
                                expression: "itemValue"
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.errorMessages, function(message) {
                              return _c(
                                "div",
                                { staticClass: "invalid-feedback" },
                                [_vm._v(_vm._s(message))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                ]
              : _vm.type === "select"
              ? [
                  _c("label", [
                    _vm._v(_vm._s(_vm.fieldName) + " "),
                    !_vm.isNullable
                      ? _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.itemValue,
                          expression: "itemValue"
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.itemValue = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _vm.isNullable
                        ? _c("option", {
                            domProps: {
                              value: null,
                              textContent: _vm._s("null")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.selectValues, function(s) {
                        return _c("option", {
                          key: s.value,
                          domProps: {
                            value: s.value,
                            textContent: _vm._s(s.displayName)
                          }
                        })
                      })
                    ],
                    2
                  )
                ]
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }